import { render, staticRenderFns } from "./GuppyChatSidebarFooter.vue?vue&type=template&id=39061f3a&"
import script from "./GuppyChatSidebarFooter.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSidebarFooter.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatSidebarFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports